// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const yanmega: PokeData = {
  "id": 469,
  "name": "yanmega",
  "height": 19,
  "weight": 515,
  "base_experience": 180,
  "types": [
    PokeType.BUG,
    PokeType.FLYING
  ],
  "api_moves": [
    "gust",
    "wing-attack",
    "tackle",
    "supersonic",
    "sonic-boom",
    "string-shot",
    "hypnosis",
    "quick-attack",
    "screech",
    "double-team",
    "slash",
    "foresight",
    "detect",
    "pursuit",
    "crunch",
    "ancient-power",
    "uproar",
    "silver-wind",
    "aerial-ace",
    "feint",
    "u-turn",
    "night-slash",
    "air-slash",
    "bug-buzz",
    "bug-bite"
  ],
  "moves": [
    "gust",
    "tackle",
    "supersonic",
    "string-shot",
    "quick-attack",
    "pursuit",
    "crunch",
    "ancient-power",
    "aerial-ace",
    "night-slash",
    "air-slash",
    "bug-buzz",
    "bug-bite"
  ],
  "evolution_chain": {
    "id": 95,
    "item": null,
    "species": [
      {
        "name": "yanma",
        "order": 223,
        "types": [
          PokeType.BUG,
          PokeType.FLYING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "yanmega",
        "order": 224,
        "types": [
          PokeType.BUG,
          PokeType.FLYING
        ],
        "evolves_from_species_id": 193,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": {
              "name": "ancient-power"
            },
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 108,
    "speed": 131,
    "ability_power": 160
  },
  "stat_changes": [],
  "catch_rate": 30,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
